import { IconCactus } from "@tabler/icons-react";
import type { ViewProps } from "@/types/components";
import { View } from "../View";

export const EmptyView = ({
  title,
  description,
  icon,
  button,
  height = "100%",
}: ViewProps) => {
  const emptyIcon = icon || IconCactus;

  return (
    <View
      title={title}
      description={description}
      icon={emptyIcon}
      button={button}
      height={height}
      color="gray.9"
    />
  );
};
